"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _regeneratorRuntime = require("@babel/runtime/regenerator");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _class, _searchTerm, _updateFilesAndInputMode, _temp;

function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

var id = 0;

function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}

var _require = require('preact'),
    h = _require.h;

var SearchInput = require('./InputView');

var Browser = require('../Browser');

var LoaderView = require('../Loader');

var Header = require('./Header');

var CloseWrapper = require('../CloseWrapper');

var View = require('../View');
/**
 * Class to easily generate generic views for Provider plugins
 */


module.exports = (_temp = (_searchTerm = /*#__PURE__*/_classPrivateFieldLooseKey("searchTerm"), _updateFilesAndInputMode = /*#__PURE__*/_classPrivateFieldLooseKey("updateFilesAndInputMode"), _class = /*#__PURE__*/function (_View) {
  _inherits(SearchProviderView, _View);

  var _super = _createSuper(SearchProviderView);

  /**
   * @param {object} plugin instance of the plugin
   * @param {object} opts
   */
  function SearchProviderView(plugin, opts) {
    var _this;

    _classCallCheck(this, SearchProviderView);

    _this = _super.call(this, plugin, opts); // set default options

    Object.defineProperty(_assertThisInitialized(_this), _updateFilesAndInputMode, {
      value: _updateFilesAndInputMode2
    });
    Object.defineProperty(_assertThisInitialized(_this), _searchTerm, {
      writable: true,
      value: void 0
    });
    var defaultOptions = {
      viewType: 'grid',
      showTitles: false,
      showFilter: false,
      showBreadcrumbs: false
    }; // merge default options with the ones set by user

    _this.opts = _objectSpread(_objectSpread({}, defaultOptions), opts); // Logic

    _this.search = _this.search.bind(_assertThisInitialized(_this));
    _this.triggerSearchInput = _this.triggerSearchInput.bind(_assertThisInitialized(_this));
    _this.addFile = _this.addFile.bind(_assertThisInitialized(_this));
    _this.handleScroll = _this.handleScroll.bind(_assertThisInitialized(_this));
    _this.donePicking = _this.donePicking.bind(_assertThisInitialized(_this)); // Visual

    _this.render = _this.render.bind(_assertThisInitialized(_this)); // Set default state for the plugin

    _this.plugin.setPluginState({
      isInputMode: true,
      files: [],
      folders: [],
      directories: [],
      filterInput: '',
      isSearchVisible: false,
      currentSelection: []
    });

    return _this;
  }

  _createClass(SearchProviderView, [{
    key: "tearDown",
    value: function tearDown() {// Nothing.
    }
  }, {
    key: "search",
    value: function search(query) {
      var _this2 = this;

      if (query && query === _classPrivateFieldLooseBase(this, _searchTerm)[_searchTerm]) {
        // no need to search again as this is the same as the previous search
        this.plugin.setPluginState({
          isInputMode: false
        });
        return;
      }

      return this.sharedHandler.loaderWrapper(this.provider.search(query), function (res) {
        _classPrivateFieldLooseBase(_this2, _updateFilesAndInputMode)[_updateFilesAndInputMode](res, []);
      }, this.handleError);
    }
  }, {
    key: "triggerSearchInput",
    value: function triggerSearchInput() {
      this.plugin.setPluginState({
        isInputMode: true
      });
    }
  }, {
    key: "handleScroll",
    value: function () {
      var _handleScroll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
        var query, response, _this$plugin$getPlugi, files;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                query = this.nextPageQuery || null;

                if (!(this.shouldHandleScroll(event) && query)) {
                  _context.next = 17;
                  break;
                }

                this.isHandlingScroll = true;
                _context.prev = 3;
                _context.next = 6;
                return this.provider.search(_classPrivateFieldLooseBase(this, _searchTerm)[_searchTerm], query);

              case 6:
                response = _context.sent;
                _this$plugin$getPlugi = this.plugin.getPluginState(), files = _this$plugin$getPlugi.files;

                _classPrivateFieldLooseBase(this, _updateFilesAndInputMode)[_updateFilesAndInputMode](response, files);

                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](3);
                this.handleError(_context.t0);

              case 14:
                _context.prev = 14;
                this.isHandlingScroll = false;
                return _context.finish(14);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 11, 14, 17]]);
      }));

      function handleScroll(_x) {
        return _handleScroll.apply(this, arguments);
      }

      return handleScroll;
    }()
  }, {
    key: "donePicking",
    value: function donePicking() {
      var _this3 = this;

      var _this$plugin$getPlugi2 = this.plugin.getPluginState(),
          currentSelection = _this$plugin$getPlugi2.currentSelection;

      var promises = currentSelection.map(function (file) {
        return _this3.addFile(file);
      });
      this.sharedHandler.loaderWrapper(Promise.all(promises), function () {
        _this3.clearSelection();
      }, function () {});
    }
  }, {
    key: "render",
    value: function render(state) {
      var _this4 = this;

      var viewOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _this$plugin$getPlugi3 = this.plugin.getPluginState(),
          didFirstRender = _this$plugin$getPlugi3.didFirstRender,
          isInputMode = _this$plugin$getPlugi3.isInputMode;

      if (!didFirstRender) {
        this.preFirstRender();
      }

      var targetViewOptions = _objectSpread(_objectSpread({}, this.opts), viewOptions);

      var _this$plugin$getPlugi4 = this.plugin.getPluginState(),
          files = _this$plugin$getPlugi4.files,
          folders = _this$plugin$getPlugi4.folders,
          filterInput = _this$plugin$getPlugi4.filterInput,
          loading = _this$plugin$getPlugi4.loading,
          currentSelection = _this$plugin$getPlugi4.currentSelection;

      var _this$sharedHandler = this.sharedHandler,
          isChecked = _this$sharedHandler.isChecked,
          toggleCheckbox = _this$sharedHandler.toggleCheckbox,
          filterItems = _this$sharedHandler.filterItems;
      var hasInput = filterInput !== '';
      var browserProps = {
        isChecked: isChecked,
        toggleCheckbox: toggleCheckbox,
        currentSelection: currentSelection,
        files: hasInput ? filterItems(files) : files,
        folders: hasInput ? filterItems(folders) : folders,
        handleScroll: this.handleScroll,
        done: this.donePicking,
        cancel: this.cancelPicking,
        headerComponent: Header({
          triggerSearchInput: this.triggerSearchInput,
          i18n: this.plugin.uppy.i18n
        }),
        title: this.plugin.title,
        viewType: targetViewOptions.viewType,
        showTitles: targetViewOptions.showTitles,
        showFilter: targetViewOptions.showFilter,
        showBreadcrumbs: targetViewOptions.showBreadcrumbs,
        pluginIcon: this.plugin.icon,
        i18n: this.plugin.uppy.i18n,
        uppyFiles: this.plugin.uppy.getFiles(),
        validateRestrictions: function validateRestrictions() {
          var _this4$plugin$uppy;

          return (_this4$plugin$uppy = _this4.plugin.uppy).validateRestrictions.apply(_this4$plugin$uppy, arguments);
        }
      };

      if (loading) {
        return h(CloseWrapper, {
          onUnmount: this.clearSelection
        }, h(LoaderView, {
          i18n: this.plugin.uppy.i18n
        }));
      }

      if (isInputMode) {
        return h(CloseWrapper, {
          onUnmount: this.clearSelection
        }, h(SearchInput, {
          search: this.search,
          i18n: this.plugin.uppy.i18n
        }));
      }

      return h(CloseWrapper, {
        onUnmount: this.clearSelection
      }, h(Browser, browserProps));
    }
  }]);

  return SearchProviderView;
}(View)), _class.VERSION = "2.0.4", _temp);

function _updateFilesAndInputMode2(res, files) {
  this.nextPageQuery = res.nextPageQuery;
  _classPrivateFieldLooseBase(this, _searchTerm)[_searchTerm] = res.searchedFor;
  res.items.forEach(function (item) {
    files.push(item);
  });
  this.plugin.setPluginState({
    isInputMode: false,
    files: files
  });
}